module.exports = __webpack_public_path__ + "img/linkedin.06ee08b7.svg";